import { render, staticRenderFns } from "./textareaField.vue?vue&type=template&id=6206ecf2&"
import script from "./textareaField.vue?vue&type=script&lang=js&"
export * from "./textareaField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports